import type { MemberDraft } from "../types";

/** Fixed Gradient Doe demographics (product plan 4.15). */
export function gradientDoeDraft(): MemberDraft {
  return {
    firstName: "Gradient",
    lastName: "Doe",
    relation: "Employee",
    subscriberMemberId: null,
    gender: "F",
    dateOfBirth: "1825-10-23",
    heightFeet: 5,
    heightInches: 6,
    weightLbs: 150,
    postalCode: null,
    ssn: null,
    notes: null,
    memberType: "GradientDoe",
  };
}

/** Why Add Gradient Doe is disabled once the group already has one. */
export const GRADIENT_DOE_EXISTS_TOOLTIP = "This group already has a Gradient Doe. A group can hold only one.";
